import { NewsItemCtaProps } from '@models/news'

const NewsItemCta = (props: NewsItemCtaProps) => {
    const newsItemCtaClass = 'home-news-item-cta'
    return (
        <div
            className={newsItemCtaClass}
            onClick={() => {
                if (!props.disabled) props.onClick()
            }}>
            <span className={`${newsItemCtaClass}__icon cu cu-${props.icon}`} />
            <span className={`${newsItemCtaClass}__title text-mini`}>{props.title}</span>
            <span className={`${newsItemCtaClass}__icon cu cu-${props.rightIcon} right-icon`} />
        </div>
    )
}

export default NewsItemCta
